import ContactUs from "./components/ContactUs";
import Hero from "./components/Hero";
import Internships from "./components/Internships";
import Projects from "./components/Projects";
import { HashLoader} from "react-spinners";
import {useState, useEffect} from 'react'

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoading(false);
    }, 4000);
  
    return () => clearTimeout(timeoutId);
  }, []);

  

 
  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-screen bg-background">
          <HashLoader color="#64fcda" loading={loading} />
        </div>
      ) : (
        <>
          <Hero />
          <Internships />
          <Projects />
          <ContactUs />    
        </>
      )}
    </>
  );
      }  
  

export default App;
